import { tryCatch } from '@wix/funnel-utils'
import React, { FC } from 'react'

import { markAsWixStudioAccount } from '../../../api/StudioWorkspaceService/markAsWixStudioAccount'
import { WixStudioWelcomeAnimation } from '../../reusable/WixStudioWelcomeAnimation'
import { WixStudioMobileRadioGroup } from './WixStudioMobileRadioGroup'
import s from './WixStudioMobileWelcome.scss'

export const WixStudioMobileWelcome: FC = () => {
  const prepend = (value: string = '') => (
    <div className={s.graphicsContainer}>
      <div className={s[`scaler-${value || 'myself'}`]}>
        <WixStudioWelcomeAnimation image={value || 'myself'} />
      </div>
    </div>
  )

  const onNext = async (value?: string) => {
    if (value === 'freelancer' || value === 'agency') {
      void tryCatch(markAsWixStudioAccount)
    }
  }

  return <WixStudioMobileRadioGroup onNext={onNext} prepend={prepend} />
}
